import React, { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { listCategories } from '@lib/util/category-handler'
import useFilterProducts from '@common/hooks/use-filter-product'
import ShopLayout from '@layouts/shop-layout'

const Deals = () => {
  const useFilter = useFilterProducts()

  return (
    <ShopLayout
      textHeader={'Deals'}
      useFilter={{ ...useFilter, hides: ['category', 'collection'] }}
    />
  )
}

export default Deals
